import { zeroClient } from '../../../../utils/clients';
import { useGetUserOpenTroveQuery } from '../../../../utils/graphql/zero/generated';
export const useGetUserOpenTrove = (account) => useGetUserOpenTroveQuery({
    variables: { user: account === null || account === void 0 ? void 0 : account.toLowerCase() },
    client: zeroClient,
});
